import {Grid, GridProps} from "@mantine/core";
import {StatisticsGroupWrapper, statisticsType, TransportCategory, transportMethod} from "@ots-frontend/ots-data";
import {PropsWithChildren} from "react";
import {HasAccess} from "../../auth/HasAccess/HasAccess";
import {StatisticInsight} from "../StatisticInsight/StatisticInsight";

export type PipelineInsightsGridProps = Omit<GridProps, 'children'> & {
  insights?: StatisticsGroupWrapper
  rateModels?: string[]
  category?: TransportCategory
  loading?: boolean
}

export const PipelineInsightsGrid = (props: PropsWithChildren<PipelineInsightsGridProps>) => {
  const {
    insights,
    rateModels,
    category,
    loading,
    children,
    ...rest
  } = props

  return (
    <Grid {...rest}>

      <HasAccess permissions={["view_cost"]}>
        <Grid.Col span={4}>
          <StatisticInsight
            statistics={insights}
            type={statisticsType.cost}
            method={transportMethod.pipeline}
            rateModels={rateModels}
            category={category}
            loading={loading}/>
        </Grid.Col>
      </HasAccess>

      <Grid.Col span={4}>
        <StatisticInsight
          statistics={insights}
          type={statisticsType.quantity}
          method={transportMethod.pipeline}
          rateModels={rateModels}
          category={category}
          loading={loading}/>
      </Grid.Col>

      {children}

    </Grid>
  )
}
